// Kalman Claudsky: examples section for the Tanach Family Tree help page.
// Contains embedded YouTube demos for the dark-mode and light-mode 3D tree animations.

import React, { Component } from 'react';
import ReactPlayer from 'react-player/youtube';

class YuchsinTreeViewer_Examples extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  getTranslatedContent(langCode) {
    if (!["he", "en"].includes(langCode)) {
      langCode = "en";
    }
    var retVal;
    if (langCode === "he") {
      retVal = <>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <b><span lang="HE" style={{fontSize:'14.0pt', fontFamily:'"Arial",sans-serif'}}>אילן יוחסין תנ"כי</span></b>
        </p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>
            להלן מספר הנפשות שאילן היוחסין התנ"כי יכול ליצור:
          </span>
        </p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>מצב כהה</span>
        </p>
        <ReactPlayer url="https://www.youtube.com/watch?v=1gVGBEXmqQs" width={560} height={315} controls={true} />

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>מצב בהיר</span>
        </p>
        <ReactPlayer url="https://www.youtube.com/watch?v=qrL95FpGonM" width={560} height={315} controls={true} />

      </>;
    } else if (langCode === "en") {
      retVal = <>

        <p className="MsoNormal"><b><span style={{fontSize:'14.0pt'}}>Tanach Family Tree</span></b></p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal">Here are some animations that the 3D Tanach Family Tree can generate:</p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal">Dark mode</p>
        <ReactPlayer url="https://www.youtube.com/watch?v=1gVGBEXmqQs" width={560} height={315} controls={true} />

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal">Light mode</p>
        <ReactPlayer url="https://www.youtube.com/watch?v=qrL95FpGonM" width={560} height={315} controls={true} />

      </>;
    }
    return retVal;
  }

  render() {
    return <>
      {this.getTranslatedContent(this.props.langCode)}
    </>
  }
}

export default YuchsinTreeViewer_Examples;
